// src/composables/api/useUserApi.ts
import { useAuthHttp } from './useAuthHttp';
import { AxiosRequestConfig } from 'axios';


export function useAppApi() {
    const { get, post, put, del } = useAuthHttp();


    const getLatestAppVersion = async (config: AxiosRequestConfig = {}): Promise => {
        return await get(`/app/get-app-version`, config);
    };
    
    const getLatestTicketingVersion = async (config: AxiosRequestConfig = {}): Promise => {
        // This endpoint should be public (no auth required)
        return await get(`/app/get-ticketing-app-version`, config);
    };

    // const addUser = async (userData: User, config: AxiosRequestConfig = {}): Promise<User> => {
    //     return await post<User>('/users', userData, config);
    // };
    //
    // const updateUser = async (id: number, userData: User, config: AxiosRequestConfig = {}): Promise<User> => {
    //     return await put<User>(`/users/${id}`, userData, config);
    // };
    //
    // const deleteUser = async (id: number, config: AxiosRequestConfig = {}): Promise<void> => {
    //     return await del<void>(`/users/${id}`, config);
    // };

    return {
        getLatestAppVersion,
        getLatestTicketingVersion
    };
}
